import api from 'api'
import { CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS } from 'api/cacheTagTypes'

import type { GeoZoneLocationExclusionResponseApi } from 'types/api/zones/geoZoneLocationExclusion'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    // The zones a user unchecked on a location; the same shape the location writes send.
    getGeoZoneLocationExclusions: build.query<GeoZoneLocationExclusionResponseApi, string>({
      query: locationId => ({ url: `/api/v1/core/locations/${locationId}/zones` }),
      providesTags: (_result, _error, locationId) => [{ type: CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS, id: locationId }],
    }),
  }),
})

export const { useGetGeoZoneLocationExclusionsQuery } = extendedApi
